<template>
  <v-card
    flat
    class="formReceivingAsset"
  >
    <v-card-title>Who is receiving the asset?</v-card-title>
    <v-radio-group
      :value="value"
      mandatory
      row
      @change="onChange"
    >
      <v-radio
        label="Counterparty"
        value="counterparty"
      />
      <v-radio
        label="Myself"
        value="firstParty"
      />
    </v-radio-group>
  </v-card>
</template>

<script>
export default {
  name: 'FormReceivingAsset',
  props: {
    value: { type: String, default: 'firstParty' }
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
.formReceivingAsset {
  .v-card__title {
    padding-left: 0;
  }
}

</style>
